import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DataTableMultiSelectFilterComponent, DataTableMultiSelectFilterOption } from '@shared/components/data-table-multi-select-filter/data-table-multi-select-filter.component';
import { ModalShellComponent, ModalShellConfig } from '@shared/components/modal-shell/modal-shell.component';

export interface SpiritualAssistanceVisitsMoreFiltersDialogData {
  locationOptions: DataTableMultiSelectFilterOption[];
  communionOptions: DataTableMultiSelectFilterOption[];
  communityOptions: DataTableMultiSelectFilterOption[];
  districtOptions: DataTableMultiSelectFilterOption[];
  areaOptions: DataTableMultiSelectFilterOption[];
  showCommunityFilters: boolean;
  values: SpiritualAssistanceVisitsMoreFilters;
}

export interface SpiritualAssistanceVisitsMoreFilters {
  location: string[];
  communion: string[];
  community: string[];
  district: string[];
  area: string[];
}

@Component({
  selector: 'app-spiritual-assistance-visits-more-filters-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    DataTableMultiSelectFilterComponent,
    ModalShellComponent,
  ],
  templateUrl: './spiritual-assistance-visits-more-filters-dialog.component.html',
  styleUrl: './spiritual-assistance-visits-more-filters-dialog.component.scss',
})
export class SpiritualAssistanceVisitsMoreFiltersDialogComponent {
  readonly modalConfig: ModalShellConfig = {
    title: 'Más filtros',
    subtitle: 'Refiná el listado de visitas de asistencia espiritual.',
    size: 'md',
    layout: 'form',
  };

  readonly form: FormGroup<{
    location: FormControl<string[]>;
    communion: FormControl<string[]>;
    community: FormControl<string[]>;
    district: FormControl<string[]>;
    area: FormControl<string[]>;
  }>;

  constructor(
    @Inject(MAT_DIALOG_DATA) readonly data: SpiritualAssistanceVisitsMoreFiltersDialogData,
    private readonly dialogRef: MatDialogRef<SpiritualAssistanceVisitsMoreFiltersDialogComponent, SpiritualAssistanceVisitsMoreFilters | null>,
  ) {
    this.form = new FormGroup({
      location: new FormControl<string[]>(data.values.location, { nonNullable: true }),
      communion: new FormControl<string[]>(data.values.communion, { nonNullable: true }),
      community: new FormControl<string[]>(data.values.community, { nonNullable: true }),
      district: new FormControl<string[]>(data.values.district, { nonNullable: true }),
      area: new FormControl<string[]>(data.values.area, { nonNullable: true }),
    });
  }

  clearFilters(): void {
    this.form.setValue({
      location: this.data.locationOptions.map(option => option.value ?? ''),
      communion: this.data.communionOptions.map(option => option.value ?? ''),
      community: this.data.communityOptions.map(option => option.value ?? ''),
      district: this.data.districtOptions.map(option => option.value ?? ''),
      area: this.data.areaOptions.map(option => option.value ?? ''),
    });
  }

  apply(): void {
    this.dialogRef.close(this.form.getRawValue());
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
